<template>
  <section class="page">
    <site-header></site-header>
    <div class='container-fluid'>
      <file-upload></file-upload>
    </div>
    <site-footer></site-footer>
  </section>
</template>

<script>
  import SiteHeader from '../components/SiteHeader';
  import SiteFooter from '../components/SiteFooter';
  import FileUpload from '../components/FileUpload';
  
  export default {
    name: 'home',
    components: {
      SiteHeader,
      SiteFooter,
      FileUpload,
    },
  };
</script>

<!-- <style src="styles/index.scss" lang="scss"></style> -->



// WEBPACK FOOTER //
// home.vue?52ca85be